const MIN_SECONDS = 15;
const MAX_SECONDS = 3600;

export const formatDuration = (seconds: number): string =>
    `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;

// "m:ss" as typed; a bare number is minutes. Null when it is not a time.
export const parseDuration = (text: string): number | null => {
    const match = /^(\d{1,3})(?::(\d{1,2}))?$/.exec(text.trim());
    if (!match) return null;
    const total = Number(match[1]) * 60 + (match[2] === undefined ? 0 : Number(match[2]));
    return Math.min(MAX_SECONDS, Math.max(MIN_SECONDS, total));
};
